module.exports = __webpack_public_path__ + "img/global.099a5bac.png";